import {IDisposable} from '@mintdata/mint-kit/api/resources/IDisposable';
import {FlowBlockId} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';

export enum FlowEventType
{
    SelectedBlockChanged = 'SelectedBlockChanged',
}

export class FlowEvent
{
    protected constructor(public readonly type:FlowEventType)
    {
    }

    public static selectedBlockChanged(selectedBlockIds:FlowBlockId[], manually:boolean = true)
    {
        return new SelectedBlockChangedEvent(selectedBlockIds, manually);
    }
}

export class SelectedBlockChangedEvent extends FlowEvent
{
    public constructor(public readonly selectedBlockIds:FlowBlockId[],
                       public readonly manually:boolean)
    {
        super(FlowEventType.SelectedBlockChanged);
    }
}

export type FlowEventListener = (e:FlowEvent) => (void);

export class FlowEventsController
{
    private _listeners:FlowEventListener[] = [];
    private _listenerDisposers:IDisposable[] = [];

    public destroy()
    {
        this._disposeListeners();
    }

    public addListener = (listener:FlowEventListener):IDisposable =>
    {
        this._listeners.push(listener);

        const disposable:IDisposable = {
            dispose: () => this.removeListener(listener),
        };

        this._listenerDisposers.push(disposable);

        return disposable;
    };

    public removeListener = (listener:FlowEventListener):void =>
    {
        this._listeners = this._listeners.filter((item:FlowEventListener) => item !== listener);
    };

    public fireEvent = (e:FlowEvent):void =>
    {
        this._listeners.forEach((listener:FlowEventListener) => listener(e));
    };

    private _disposeListeners()
    {
        this._listenerDisposers.forEach(({dispose}) => dispose());
    }
}












